export const INSIGHT_ROUTE = "insights"
